// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Permissions
import { Resource, usePermissions } from '@/modules/Permissions';

// Components
import { StyledContentBlock, StyledPageWrapper } from '../Styled';
import { Table } from '@/ui';
import { ProductOfMonthFiltersContainer } from '../../containers';
import { useGetProductsOfMonthTableColumns } from './columns';
import { Pagination } from '@/components';

// Models
import { IProduct } from '@/models/products.model';

type TProductsOfMonthList = {
  productsList: IProduct[];
  isLoading: boolean;
  setProductForDelete: (product: IProduct) => void;
  handleEditClick: (product: IProduct) => void;
  currentPage: number;
  total: number;
  onPageChange: (page: number) => void;
};

const ProductsOfMonthList = ({
  isLoading,
  setProductForDelete,
  handleEditClick,
  productsList,
  currentPage,
  total,
  onPageChange,
}: TProductsOfMonthList) => {
  const { t } = useTranslation(['products']);
  const { canManage } = usePermissions();
  const columns = useGetProductsOfMonthTableColumns({
    t,
    handleEditClick,
    setProductForDelete,
    canManage: canManage(Resource.PRODUCT_OF_MONTH),
  });

  return (
    <StyledPageWrapper>
      <StyledContentBlock>
        <Table
          columns={columns}
          dataSource={productsList || []}
          rowKey="id"
          loading={isLoading}
          components={{
            header: {
              wrapper: ProductOfMonthFiltersContainer,
            },
          }}
        />
        <Pagination current={currentPage} total={total} onChange={onPageChange} />
      </StyledContentBlock>
    </StyledPageWrapper>
  );
};

export default ProductsOfMonthList;
